import React from "react";

import { faTrash } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { ActionButton } from "components/AgGrid/ActionButton";

export const ActionsColumn = ({ data, context }) => {
  return (
    <ActionButton
      data-tour="action-delete"
      type="button"
      onClick={() => context.openDeleteDialog(data.id)}
    >
      <FontAwesomeIcon icon={faTrash} />
      &nbsp;Delete
    </ActionButton>
  );
};
